import { render, staticRenderFns } from "./gsCustomerServiceGroup.vue?vue&type=template&id=62b61fdd&scoped=true"
import script from "./gsCustomerServiceGroup.vue?vue&type=script&lang=js"
export * from "./gsCustomerServiceGroup.vue?vue&type=script&lang=js"
import style0 from "./gsCustomerServiceGroup.vue?vue&type=style&index=0&id=62b61fdd&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./gsCustomerServiceGroup.vue?vue&type=style&index=1&id=62b61fdd&prod&lang=css"
import style2 from "./gsCustomerServiceGroup.vue?vue&type=style&index=2&id=62b61fdd&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b61fdd",
  null
  
)

export default component.exports